/**
 * Recruit Graphics portal branding.
 * Dark base with chrome/silver accent. Matches chrome logo aesthetic.
 */
export const PORTAL_THEME = {
  // Backgrounds
  pageBackground:  "#000000",   // the store's background-1 — the logo PNG's black must match it
  cardBackground:  "#0d0d0d",
  cardBorder:      "#1e1e1e",
  // Store cards: no glow, a 10%-opacity edge (settings_data.json card_border_opacity).
  cardEdge:        "1px solid rgba(237,232,224,0.12)",
  inputBorder:     "#2a2a2a",

  // Text
  text:       "#ede8e0",   // warm white
  textMuted:  "#9a9189",   // warm mid-tone gray

  // Legacy button keys (kept for pages that reference them)
  buttonBackground: "#ffffff",
  buttonText:       "#000000",
  buttonBorder:     "#ffffff",
  linkAsButtonBg:   "#ffffff",
  linkAsButtonText: "#000000",
  linkAsButtonBorder: "#ffffff",

  // Brand accent — chrome/silver
  accentOrange: "#c8c8c8",   // chrome silver — replaces orange throughout
  accentAmber:  "#e8e8e8",   // lighter chrome for hover/highlight
  glowOrange:   "rgba(200,200,200,0.10)",

  // Chrome button — real chrome effect: bright top highlight → dark mid-band → lower reflection
  chromeGradient: "linear-gradient(180deg, #ffffff 0%, #e0e0e0 8%, #b8b8b8 30%, #787878 50%, #b0b0b0 68%, #e4e4e4 85%, #c0c0c0 100%)",
  chromeButtonShadow: "inset 0 1px 0 rgba(255,255,255,0.9), inset 0 -1px 0 rgba(0,0,0,0.25), 0 2px 8px rgba(0,0,0,0.6), 0 1px 2px rgba(0,0,0,0.4)",
  chromeBorder: "1px solid #606060",
  chromeButtonText: "#111111",

  // Semantic
  error:   "#ef4444",
  success: "#22c55e",
  sliderAccent: "#c8c8c8",

  // Typography
  fontFamily:         '"Figtree", "DM Sans", system-ui, -apple-system, sans-serif',
  fontFamilyHeadings: '"Open Sans Condensed", "Figtree", "DM Sans", system-ui, sans-serif',
  menuFontSize: 14,
  // The store's heading font is Open Sans Condensed Light (type_header_font
  // open_sans_condensed_n3). Body stays Figtree — the store's Avenir Next is
  // licensed through Shopify only.
  headingWeight: 300,

  // Store shapes: buttons, cards and inputs square; option chips 40px pills.
  radius:     0,
  chipRadius: 40,
  contentWidth: 1600,

  // Page background — subtle silver mist instead of orange
  mistGradient: `
    radial-gradient(ellipse 80% 55% at 50% -8%, rgba(200,200,200,0.10) 0%, transparent 65%),
    radial-gradient(ellipse 45% 30% at 90% 95%, rgba(200,200,200,0.04) 0%, transparent 55%),
    #000000
  `.trim(),
};
